export const get = (p, o) => p.reduce((xs, x) =>
    (xs && xs[x]) ? xs[x] : null, o);

export const getString = (p, o) => p.reduce((xs, x) =>
    (xs && xs[x]) ? xs[x] : '', o);

export const fortmatAmount = (valor: any) => {
        return Number.parseFloat(
          isNaN(valor) ? valor : parseFloat(valor).toFixed(2)
        );
      };